import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as common from '../../../../common'

const DOC = gql`
  ${common.gql.dms.models.fragments.attribute.DOC}
  ${common.gql.dms.models.fragments.entity.DOC}
  ${common.gql.dms.models.fragments.dimension.DOC}
  ${common.gql.dms.models.fragments.enum.DOC}
  ${common.gql.dms.models.fragments.snapshot.DOC}

  query DmsModels($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        models {
          __typename
          ...FragmentDmsAttribute
          ...FragmentDmsEntity
          ...FragmentDmsSnapshot
          ...FragmentDmsDimension
          ...FragmentDmsEnum
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default<
  graphql.schema.DmsModelsQuery,
  ents.core.dms.models.Any[] | undefined,
  ents.core.dms.models.Any[]
>(
  graphql.transformers.OUT.select(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'models',
        graphql.transformers.OUT.list(
          graphql.transformers.OUT.discriminateOn('__typename', {
            DmsAttribute: common.gql.dms.models.fragments.attribute.TRANSFORMER,
            DmsDimension: common.gql.dms.models.fragments.dimension.TRANSFORMER,
            DmsEntity: common.gql.dms.models.fragments.entity.TRANSFORMER,
            DmsEnum: common.gql.dms.models.fragments.enum.TRANSFORMER,
            // TODO: finish implementing these transformers
            DmsPurpose: graphql.transformers.OUT.always(undefined),
            DmsSnapshot: common.gql.dms.models.fragments.snapshot.TRANSFORMER,
            DmsStructure: graphql.transformers.OUT.always(undefined),
          }),
          { onNullish: 'remove' },
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.DmsModelsQuery,
  ents.core.dms.models.Any[],
  graphql.schema.DmsModelsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
